var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4121 7.69434H15.6436V13.0708C15.6436 14.006 15.5378 14.7487 15.3262 15.2988C15.1146 15.849 14.7316 16.2975 14.1772 16.6445C13.6271 16.9873 12.9035 17.1587 12.0063 17.1587C11.1346 17.1587 10.4215 17.0085 9.86719 16.708C9.31283 16.4076 8.91715 15.9738 8.68018 15.4067C8.4432 14.8354 8.32471 14.0568 8.32471 13.0708V7.69434H9.55615V13.0645C9.55615 13.8727 9.63021 14.4694 9.77832 14.8545C9.93066 15.2354 10.1888 15.5295 10.5527 15.7368C10.9209 15.9442 11.3695 16.0479 11.8984 16.0479C12.804 16.0479 13.4494 15.8426 13.8345 15.4321C14.2196 15.0216 14.4121 14.2324 14.4121 13.0645V7.69434Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30273 18.8535H16.6909V19.8057H7.30273V18.8535Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/Underline.3dd13b15fc80ada3102296fbf215678e.svg";
export { ForwardRef as ReactComponent };